module.exports = __webpack_public_path__ + "img/banner01.b286afae.jpg";